var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSyncStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.687 13.38c-.535-3.76 1.742-7.42 5.397-8.427 3.393-.935 6.867.718 8.44 3.783",
    stroke: "var(--foreground)",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m4.661 13.574-.346.361a.5.5 0 0 0 .72-.03l-.374-.331zm2.213-1.743a.5.5 0 1 0-.748-.662l.748.662zm-4.028-.692a.5.5 0 0 0-.693.722l.693-.722zm2.189 2.766 1.839-2.074-.748-.662-1.839 2.074.748.662zm-.027-.692-2.162-2.074-.693.722 2.162 2.074.693-.722z",
    fill: "var(--foreground)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.294 11.126c.576 3.787-1.706 7.488-5.386 8.503-3.335.919-6.749-.663-8.359-3.629",
    stroke: "var(--foreground)",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m19.33 11.007.34-.368a.5.5 0 0 0-.664-.012l.325.38zm-2.655 1.613a.5.5 0 1 0 .65.76l-.65-.76zm4.486.748a.5.5 0 0 0 .677-.736l-.677.736zm-2.155-2.74-2.33 1.992.648.76 2.331-1.993-.649-.76zm-.014.748 2.17 1.992.677-.736-2.17-1.993-.677.737z",
    fill: "var(--foreground)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncStatus);
export default __webpack_public_path__ + "static/media/sync-status.981c26621ca8adb24a778fc8dd64c604.svg";
export { ForwardRef as ReactComponent };